import {ChangeDetectionStrategy, Component, Input} from '@angular/core';
import {ModalController} from '@ionic/angular';
import {UnrModalDismissEventEnum} from './unr-modal-dismiss-event.enum';

@Component({
  selector: 'unr-modal',
  templateUrl: './unr-modal.component.html',
  styleUrls: ['./unr-modal.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class UnrModalComponent {

  static readonly DISMISS_DATA_KEY = 'modalDismissData';
  static readonly DISMISS_VALUE_KEY = 'modalDismissValue';

  @Input() title = '';
  @Input() description = '';
  @Input() secondaryLabel = '';
  @Input() primaryLabel = '';

  constructor(private modalController: ModalController) {
  }

  onSecondaryClick(): void {
    this.modalController.dismiss({
      [UnrModalComponent.DISMISS_DATA_KEY]: UnrModalDismissEventEnum.Secondary
    });
  }

  onPrimaryClick(): void {
    this.modalController.dismiss({
      [UnrModalComponent.DISMISS_DATA_KEY]: UnrModalDismissEventEnum.Primary
    });
  }
}
